import { createContext, useState } from 'react';

export interface LoadingStateContext {
    loading: boolean;
    showLoading: () => void;
    hideLoading: () => void;
}

const initialState: Pick<LoadingStateContext, 'loading'> = {
    loading: false,
}

export const LoadingContext = createContext({} as LoadingStateContext)

interface IElement { children: JSX.Element | JSX.Element[] }

export const LoadingProvider = ({ children }: IElement) => {

    const [session, setSession] = useState(initialState)

    const showLoading = () => {
        setSession({ loading: true })
    }

    const hideLoading = () => {
        setSession({ loading: false })
    }

    return (
        <LoadingContext.Provider
            value={{
                ...session,
                showLoading,
                hideLoading
            }}
        >
            {children}
        </LoadingContext.Provider>
    )
}